// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"904dd03f","232":"93b0991a","293":"9413d530","432":"58f5ba9e","474":"c8ce3380","506":"9ad78102","536":"05939b4f","566":"6610f921","684":"5111b6bd","925":"ffb60e55"}[chunkId] + ".chunk.js";
};